module.exports = __webpack_public_path__ + "img/grid_green.875c5c84.png";